import { createAsyncThunk } from "@reduxjs/toolkit";
import { directoryAPI } from "libs/apiClient/Directory";

export const getOrganizationsDirectory = createAsyncThunk(
	"directoriesSlice/getOrganizationsDirectory",
	async (_, { rejectWithValue }) => {
		try {
			return await directoryAPI.organizationsList().then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getProcessClassesDirectory = createAsyncThunk(
	"directoriesSlice/getProcessClassesDirectory",
	async (_, { rejectWithValue }) => {
		try {
			return await directoryAPI.bpClassesList().then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getObjectsTypesDirectory = createAsyncThunk(
	"directoriesSlice/getObjectsTypesDirectory",
	async (_, { rejectWithValue }) => {
		try {
			return await directoryAPI.objectTypesList().then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getActivityAreasDirectory = createAsyncThunk(
	"directoriesSlice/getActivityAreasDirectory",
	async (_, { rejectWithValue }) => {
		try {
			return await directoryAPI.activityAreasList().then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getResponsiblesDirectory = createAsyncThunk(
	"directoriesSlice/getResponsiblesDirectory",
	async (id: number, { rejectWithValue }) => {
		try {
			return await directoryAPI.employeesList({ org_id: id }).then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getOwnershipTypesDirectory = createAsyncThunk(
	"directoriesSlice/getOwnershipTypesDirectory",
	async (_, { rejectWithValue }) => {
		try {
			return await directoryAPI.ownershipTypesList().then((r) => r.data);
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);
